import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useCompletionHandler = () => {
  const navigate = useNavigate();
  const { routineId } = useParams();
  const queryClient = useQueryClient();

  const handleCompletion = async () => {
    try {
      const { data: user } = await supabase.auth.getUser();
      
      if (!user?.user?.id || !routineId) {
        console.error("Missing user ID or routine ID");
        return;
      }

      // Verificar si la rutina ya fue completada hoy
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const { data: existingCompletions } = await supabase
        .from('routine_progress')
        .select('id')
        .eq('user_id', user.user.id)
        .eq('routine_id', routineId)
        .gte('completed_at', today.toISOString());

      if (existingCompletions && existingCompletions.length > 0) {
        toast({
          variant: "destructive",
          title: "Rutina ya completada",
          description: "Esta rutina ya fue marcada como completada hoy"
        });
        navigate('/');
        return;
      }

      console.log("Saving routine completion:", {
        userId: user.user.id,
        routineId
      });

      const { error } = await supabase
        .from('routine_progress')
        .insert({
          user_id: user.user.id,
          routine_id: routineId,
          completed_at: new Date().toISOString(),
          exercise_progress: []
        });

      if (error) {
        console.error("Error saving routine completion:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "No se pudo guardar el progreso de la rutina"
        });
        return;
      }

      // Invalidar cache para actualización instantánea del progreso
      await queryClient.invalidateQueries({ 
        queryKey: ['routine-progress'] 
      });

      console.log("Routine completion saved successfully");
      toast({
        title: "¡Rutina completada!",
        description: "Tu progreso ha sido guardado"
      });
      
      navigate('/');
    } catch (error) {
      console.error("Error in handleCompletion:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Ocurrió un error al guardar el progreso"
      });
    }
  };

  return { handleCompletion };
};